import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const BranchService = {
  // Define your API functions here
  create: async (data) => {
    const response = await apiService.post("/branchoffices", data);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/branchoffices/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  getList: async ({ searchText = "", page = 1, pageSize = 10 }) => {
    const params = new URLSearchParams({
      ...(searchText && { searchText }),
      page: page.toString(),
      pageSize: pageSize.toString(),
    });

    const response = await apiService.get(`/branchoffices?${params.toString()}`);
    return response.data;
  },
  getDetail: async (id) => {
    const response = await apiService.get(`/branchoffices/${id}`);
    return response.data;
  },


  delete: async (id) => {
    const response = await apiService.delete(`/branchoffices/${id}`);
    return response.data;
  },
};

export default BranchService;
